module.exports = __webpack_public_path__ + "static/img/airhdl-cl.5d30a87f.jpg";